import tw from 'tailwind-styled-components'
import {cn} from '@containers/html-utils'

export const TwFileList = tw.div<{$heightRestricted?: boolean}>`
  flex
  flex-wrap
  gap-8
  ${p => cn(p.$heightRestricted && cn('max-h-80', 'overflow-y-auto'))}
`
